import { array_ } from ".";

export const getMobileHeaderList = (res) => {
  const data = array_(res);
  return array_(data[0]?.children);
};

export const getColumnInfo = (res) => {
  const rootData = array_(res?.rootData);
  const info = array_(rootData[0]?.oneData); // 接口实际有效信息
  // 整理成字典
  const infoDict = info.reduce((acc, cur) => {
    return { ...acc, [cur?.boxcode]: cur };
  }, {});
  // 此处命名以设计图为参考, 部分内容可由用户自定义配置
  const recentNews = infoDict["2"]; // 第1个窗口信息[]
  const middleMenu = infoDict["2"]; // 第2个窗口信息[]
  const specialColumn = infoDict["3"]; // 第3个窗口信息[]
  const videoColumn = infoDict["4"]; // 第4个窗口信息[]
  const learningResource = infoDict["5"]; // 第5个窗口信息[]

  return {
    recentNews,
    middleMenu,
    specialColumn,
    videoColumn,
    learningResource,
  };
};
